{
    "homePage": {
        "heading": {
            "result": "Your Result",
            "productNotFound": "No products found"
        },
        "button": {
            "viewMoreBtn": "View More Products",
            "addBtn": "Add To Cart",
            "customizeBtn": "CUSTOMIZE"
        }
    },
    "currency": {
        "rs": "₹"
    },
    "productOffer": {
        "off": "OFF"
    },
    "productList": {
        "label": {
            "priceHighToLow": "Price: High to low",
            "priceLowToHigh": "Price: Low to high",
            "sortPriceHighToLow": "Price: High to low",
            "sortPriceLowToHigh": "Price: Low to high",
            "sortByPrice": "SORT BY:Price",
            "filters": "FILTERS",
            "categories": "CATEGORIES",
            "customerReview": "CUSTOMER REVIEW",
            "discountRange": "DISCOUNT RANGE"
        }
    },
    "contact": {
        "contactDetails": {
            "phoneNumber": "+91 7338617766",
            "emailAddress": "contact@funfigz.com",
            "address": "Shilpitha Tech Park, 8th Floor 55/3 55/4, Devarabisanahalli Rd opposite Sakra World Hospital Devarabisanahalli, Bellandur, Bengaluru, Karnataka 560103",
            "weekdays": "Monday - Friday: 9am - 6pm",
            "weekendSat": "Saturday - Closed",
            "weekendSun": "Sunday - Closed"
        },
        "heading": {
            "contactHeading": "Get In Touch",
            "contactInfoTitle": "Contact Information",
            "subHeading": "We'd love to hear from you! Reach out and let's create something amazing together.",
            "rightHeading": "Send Us a Message",
            "rightSubHeading": "Fill out the form and we'll contact you within 24 hours",
            "bottomPara": "We respect your privacy. Your information will never be shared.",
            "locationTitle": "Find Us Here"
        },
        "label": {
            "name": "Full Name",
            "email": "Email Address",
            "subject": "Subject",
            "message": "Message",
            "officeLocation": "Office Location",
            "workingHours": "Working Hours",
            "phone": "Phone",
            "emailTitle": "Email"
        },
        "invalidMessage": {
            "mandatory": "field is mandatory.",
            "emailInvalid": "Please enter a valid email address (e.g., john@gmail.com).",
            "numberSpecialInvalid": "Use letters only - no numbers or special characters."
        },
        "button": {
            "submitBtn": "Submit"
        },
        "placeholder": {
            "name": "Enter your full name",
            "email": "your.@example.com",
            "subject": "What is this regarding?",
            "message": "Tell us more about your inquiry..."
        }
    },
    "wishlist": {
        "heading": {
            "wishlist": "My Wishlist"
        },
        "returnMessage": "7 days return available",
        "productUnavail": "Product is currently unavailable.",
        "messageSaveItems": "Save items that you like in your wishlist. Review them anytime and easily move them to bag",
        "button": {
            "moveToCartBtn": "Move To Cart",
            "backToHomeBtn": "Back To Home",
            "viewMoreBtn": "View More",
            "addToCartBtn": "Add To Cart",
            "shopNowBtn": "Shop Now",
            "proceedToBuy": "Proceed To Buy"
        },
        "message": {
            "movetToCart": "Move to Cart"
        },
        "outOfStock": "OUT OF STOCK"
    },
    "cart": {
        "shapeFacetype": {
            "node": "Node",
            "hole": "Hole",
            "plane": "Plane"
        },
        "returnMessage": "7 days return available",
        "productUnavail": "Product is currently unavailable.",
        "minOrderAmount": "Note: The minimum purchase amount is Rs 200. Please add more items to your cart.",
        "cartMessage1": "Looks like you haven't made your choice yet...",
        "cartMessage2": "Check what we've got for you and get it swished!",
        "emptyCart": "Empty Cart",
        "headingCart": "Your Cart",
        "outOfStock": "OUT OF STOCK",
        "priceDetails": {
            "priceDetails": "Price Details",
            "totalMrp": "Total MRP",
            "discountMrp": "Discount on MRP",
            "totalAmount": "Total Amount"
        },
        "button": {
            "checkOutBtn": "Check Out",
            "backToHomeBtn": "Back To Home",
            "goToWishlist": "Go to your Wishlist",
            "moveToCart": "Move to cart",
            "proceedToBuy": "Proceed to Buy"
        },
        "label": {
            "remove": "Remove",
            "moveToWishlist": "Move to Wishlist",
            "seeMoreLikeThis": "See more like this",
            "share": "Share"
        }
    },
    "order": {
        "orderDetails": {
            "orderId": "Order ID",
            "refundAmount": "Refund Amount",
            "payment": "Payment",
            "orderStatus": "Order Status",
            "paymentStatus": "Payment Status",
            "refundStatus": "Refund Status",
            "productName": "Product Name",
            "quantity": "Quantity",
            "price": "Price",
            "subTotal": "Sub Total",
            "couponDiscount": "Coupon Discount",
            "shipping": "Shipping",
            "total": "Total Amount",
            "coinsUsed": "Coins Used",
            "payableAmount": "Payable Amount",
            "amountCharged": "Amount Charged",
            "name": "Name",
            "phoneNo": "Mobile number",
            "email": "Email",
            "address": "Address",
            "status": "Status",
            "viewDetails": "View Details",
            "viewCount": "view count",
            "shape": "Blocks",
            "orderOn": "Order On",
            "shippingAddress": "Shipping Address",
            "orderSummary": "Order Summary",
            "notifyMessage": "One time exchange or return is allowed per order."
        },
        "paymentPendingMessage": "The payment status will update within 20 minutes.",
        "refundMessage": "If the amount is deducted from your account, it will be refunded to your account within 5-7working days.",
        "OrderNotFound": "NO ORDER FOUND",
        "trackOrderMessage": "Looks like you haven't made your order yet.",
        "helpRequestMailSent": "HelpRequest sent successfully",
        "failedRequest": "Failed to send help request email",
        "button": {
            "exchangeBtn": "Exchange",
            "helpBtn": "Help",
            "viewMoreBtn": "View More",
            "backToHomeBtn": "Back To Home",
            "addReviewBtn": "Add Review",
            "returnBtn": "Return",
            "cancelBtn": "Cancel"
        },
        "heading": {
            "orderDetail": "Order Details",
            "yourOrder": "Your Orders",
            "items": "Your Items",
            "cancelItems": "Cancelled Items",
            "returnItems": "Returned Items",
            "exchangeItems": "Exchanged Items",
            "trackOrder": "Track Your Order",
            "dataNotFound": "No Data Found"
        },
        "checkbox": {
            "selectAll": "Select All"
        }
    },
    "profile": {
        "button": {
            "uploadBtn": "Upload",
            "removeBtn": "Remove",
            "saveBtn": "Save",
            "cancelBtn": "Cancel",
            "addNewBtn": "Add New",
            "editBtn": "Edit",
            "deleteBtn": "Delete",
            "setDefault": "Set as Default"
        },
        "heading": {
            "address": "Address"
        },
        "label": {
            "email": "Email",
            "default": "Default",
            "account": "Account",
            "overview": "Overview",
            "order": "Order",
            "order&Status": "Orders & Status",
            "rewards": "Rewards",
            "myStructure": "My Structure",
            "profile": "Profile",
            "deleteAccount": "Delete Account",
            "address": "Addresss",
            "legal": "Legal",
            "logout": "Log Out",
            "term": "Terms & conditions",
            "policy": "Privacy policy"
        },
        "invalidMessage": {
            "mandatory": "field is mandatory.",
            "emailInvalid": "Please use a valid email format.",
            "maximumFileSize": "The maximum allowed file size for images is 5 MB. Please select a smaller file."
        },
        "successMessage": {
            "add": "Added Successfully"
        }
    },
    "userDetails": {
        "heading": {
            "userDetailsProfile": "Enter Profile Information",
            "userDetailsAddress": "Enter Address"
        },
        "button": {
            "save&ContinueBtn": "Save & Continue"
        }
    },
    "profileDetails": {
        "label": {
            "name": "Name",
            "phoneNo": "Mobile number",
            "email": "Email",
            "age": "Age"
        },
        "invalidMessage": {
            "mandatory": "field is mandatory.",
            "emailInvalid": "Please use a valid email format.",
            "numberSpecialInvalid": "cannot contain numbers or special characters.",
            "mobileNoInvalid": "Please enter a valid 10-digit phone number."
        },
        "placeholder": {
            "name": "Enter your name",
            "phoneNo": "Enter your monbile number",
            "email": "Enter your email",
            "age": "Enter your age"
        }
    },
    "addressDetails": {
        "label": {
            "name": "Name",
            "phoneNo": "Mobile number",
            "age": "Age",
            "house&Floor": "House No. & Floor",
            "address": "Address",
            "pincode": "Pincode",
            "city": "City",
            "state": "State",
            "addressType": "Select Address Type",
            "setDefault": "Make this as my default address",
            "home": "Home",
            "work": "Work",
            "other": "Other"
        },
        "successMessage": {
            "update": "Update Successfully"
        },
        "invalidMessage": {
            "mandatory": "field is mandatory.",
            "numberSpecialInvalid": "cannot contain numbers or special characters.",
            "mobileNoInvalid": "Please enter a valid 10-digit phone number.",
            "pincodeInvalid": "Please enter a valid pincode."
        },
        "placeholder": {
            "name": "Enter recipient's name",
            "phoneNo": "Enter recipient's mobile number",
            "house&Floor": "House No. & Floor",
            "address": "Address",
            "pincode": "Pincode",
            "city": "City",
            "state": "State"
        }
    },
    "footer": {
        "privacyPolicy": "Privacy Policy",
        "termsConditions": "Terms & Conditions",
        "aboutUs": "About Us",
        "copyRight": "Funfigz • All rights reserved",
        "home": "Home",
        "explore": "Explore",
        "careers": "Careers",
        "contact": "Contact",
        "phone": "9366570242",
        "mail": "contact@funfigz.com",
        "message": "AT Funfigz, we believe creativity sparks innovation. We blend ideas, fun, and design to craft unforgettable experiences.make it all capital"
    },
    "structure": {
        "heading": {
            "myStructures": "My Structure"
        },
        "label": {
            "filter": "Filter",
            "structureNotPresent": "No items are present"
        },
        "option": {
            "select": "Select",
            "publish": "Publish",
            "delete": "Delete",
            "properties": "Properties",
            "all": "All"
        },
        "button": {
            "viewMoreBtn": "View More",
            "createStructure": "CREATE STRUCTURE",
            "goToDesigner": "Go To Designer",
            "publishBtn": "Publish",
            "deleteBtn": "Delete",
            "unselectAllBtn": "Unselect All",
            "selectAllBtn": "Select All"
        },
        "noStructure": {
            "noStructureFound": "No structures found.",
            "noStructureFoundMessage": "You haven’t created any structures yet, but you are quite close to designing your dream by logging in to Designer."
        }
    },
    "notification": {
        "heading": {
            "notifications": "Notifications",
            "emptyNotification": "Empty Notification"
        },
        "checkbox": {
            "selectAll": "Select All"
        },
        "button": {
            "deleteBtn": "Delete",
            "viewMoreBtn": "View More",
            "backToHomeBtn": "Back To Home"
        },
        "message": {
            "notificationMessage": "We will notify you when something arrives...",
            "selectedNotificationsDeletedsuccessfully": "Selected notifications are deleted successfully",
            "Deletedsuccessfully": "Notification deleted successfully"
        }
    },
    "reward": {
        "heading": {
            "coupons&Rewards": "Rewards",
            "coinBalance": "Coin Balance",
            "noReward": "No Rewards Found",
            "noRewardMessage": "Oops! There's no rewards yet...",
            "title": "Your Reward",
            "transationDetails": "Transaction History",
            "coinsDetails": "Coins Details",
            "subHeading": "Track your rewards and redeem exciting toy offers."
        },
        "button": {
            "viewMoreBtn": "Load More Transactions",
            "backToHomeBtn": "Back To Home"
        },
        "transaction": {
            "title": {
                "order": "Order Id: {{orderId}}",
                "refund": "Refund from Order Id: {{orderId}}",
                "structure": "Structure ID: {{structureId}}",
                "unknown": "Unknown"
            }
        }
    },
    "dataGrid": {
        "dataNotFound": "No data found"
    },
    "genericDialogBox": {
        "label": {
            "description": "Description",
            "return": "Return",
            "accountHolderName": "Account Holder Name",
            "accountNo": "Account Number",
            "ifscCode": "IFSC Code",
            "bankDetails": "Via Bank",
            "upiId": "Via UPI",
            "structureName": "Structure Name",
            "status": "Status",
            "search": "Search",
            "name": "Name",
            "count": "Count",
            "total": "Total"
        },
        "placeHolder": {
            "searchStructure": "Search structures"
        },
        "loadStructure": {
            "created": "Created",
            "updated": "Updated"
        },
        "noData": {
            "noStructureFound": "No structures found."
        },
        "button": {
            "addNewBtn": "Add New",
            "submitBtn": "Submit",
            "closeBtn": "Close",
            "cancelBtn": "Cancel",
            "confirmBtn": "Confirm",
            "removeBtn": "Remove",
            "okBtn": "Ok",
            "returnBtn": "Return",
            "exchangeBtn": "Exchange",
            "yesBtn": "Yes",
            "publishBtn": "Publish Structure",
            "deleteBtn": "Delete",
            "saveBtn": "Save",
            "updateBtn": "Update",
            "approveBtn": "Approve",
            "rejectBtn": "Reject",
            "replaceBtn": "Replace",
            "move": "Move",
            "getStartedBtn": "Get Started",
            "skipBtn": "Skip",
            "moveToWishlist": "Move to Wishlist"
        },
        "heading": {
            "personalInfo": "Personal Information",
            "address": "Address"
        },
        "invalidMessage": {
            "mandatory": "field is mandatory.",
            "accountNameInvalid": "Please enter a valid Name.",
            "accountnoInvalid": "Please enter a valid Account number.",
            "ifscInvalid": "Please enter a valid IFSC code.",
            "upiId": "Please enter a valid UPI ID.",
            "upiIdInvalid": "Please enter a valid UPI ID.",
            "whiteSpaceInvalid": "cannot contain only whitespace."
        },
        "unavailableProduct": {
            "title": "Remove from Wishlist",
            "content": "Products will be removed from the Wishlist due to being unavailable!"
        },
        "removeItemWishlist": {
            "title": "Remove from Wishlist",
            "content": "Are you sure you want to remove this item from Wishlist?"
        },
        "cancelOrder": {
            "title": "Cancel Order",
            "onlineContent": "Order will be cancelled, and the amount will be refunded within 5-7 working days",
            "codContent": "The order has been cancelled. Since the payment method was Cash on Delivery, no charges apply."
        },
        "returnOrder": {
            "title": "Return Order",
            "content": "Please provide your feedback for returning this order:",
            "placeHolder": {
                "return": "Reason for Returning"
            }
        },
        "viewCount": {
            "title": "Shape Details"
        },
        "onlineReturnOrder": {
            "title": "Return Order",
            "content": "Please provide your feedback for returning this order:",
            "content2": "Select your option:"
        },
        "help": {
            "title": "Thank you for your interest in Funfigz. Please fill out the form below, and we’ll get back to you within 24 hours.",
            "label": {
                "message": "Message"
            },
            "placeHolder": {
                "message": "Please write your concern"
            },
            "button": {
                "continueBtn": "Continue"
            }
        },
        "exchangeOrder": {
            "title": "Exchange Products",
            "content": "Please provide your feedback for exchanging these products:",
            "label": {
                "message": "Message"
            },
            "placeHolder": {
                "message": "Enter Your Query..."
            }
        },
        "unavailableProductCart": {
            "title": "Product Unavailable",
            "content": "Product(s) will be removed from the cart due to being unavailable!"
        },
        "removeCart": {
            "title": "Move from Cart",
            "content": "Are you sure you want to remove this item from cart?"
        },
        "notification": {
            "title": "Notification"
        },
        "deleteNotification": {
            "title1": "Delete Notifications",
            "title2": "Delete Notification",
            "content": "Are you sure you want to delete the selected notifications?",
            "content2": "Are you sure you want to delete this notification?"
        },
        "bulkPublish": {
            "title": "Publish Structures",
            "content": "Are you sure you want to publish all of these structures ({{ count }})? This action cannot be undone."
        },
        "bulkDelete": {
            "title": "Delete Structures",
            "content": "Are you sure you want to permanently delete all of these structures({{ count }})? This action cannot be undone."
        },
        "publishStructure": {
            "title": "Publish Structure",
            "content": "Are you sure you want to publish this structure? Once published, it will be visible to all users after admin approval."
        },
        "deleteStructure": {
            "title": "Delete Structure",
            "content": "Are you sure you want to permanently delete this structure? This action cannot be undone."
        },
        "structureProperties": {
            "title": "Structure properties"
        },
        "loadStructures": {
            "title": "Load Structure"
        },
        "saveAndEditStructure": {
            "title1": "Save Structure",
            "title2": "Update Structure"
        },
        "SaveAndPublishStructure": {
            "title": "Save and Publish Structure"
        },
        "updateAndPublishStructure": {
            "title": "Update and Publish Structure",
            "content": "Are you sure you want to update and publish this structure? Once published, it will be visible to all users after admin approval."
        },
        "dispatch": {
            "title": "Enter Courier Information",
            "label": {
                "courierName": "Courier Name",
                "awbNumber": "AWB Number"
            },
            "placeholder": {
                "courierName": "Enter Courier Name",
                "awbNumber": "Enter AWB Number"
            }
        },
        "pickupSchedule": {
            "title": "Enter the Pickup Scheduled",
            "label": {
                "date": "Date",
                "time": "Time"
            },
            "placeholder": {
                "date": "Choose a date",
                "time": "Select a time"
            }
        },
        "refundInitiated": {
            "title": "Refund Initiated",
            "content": "Please provide UDR number:",
            "placeholder": {
                "udrNumber": "Insert UDR number"
            }
        },
        "approveRejectComment": {
            "title": "What would you like to do with this review?",
            "approve": "Approve Review",
            "reject": "Reject Review",
            "placeholder": {
                "reason": "Enter the reason for rejecting this review"
            }
        },
        "rejectStructure": {
            "title": "Reason for rejection",
            "placeHolder": {
                "reason": "Reason for rejection"
            }
        },
        "colorChange": {
            "title": "Choose Option",
            "label": {
                "singleFace": "Single Face",
                "fullFace": "Full Face"
            }
        },
        "deleteAddress": {
            "title": "Delete Address",
            "content": "Are you sure you want to delete this address?"
        },
        "askToSaveTheStructure": {
            "title": "Confirmation",
            "content": "Your current structure will be replaced by another structure. Do you want to {{action}} it?"
        },
        "onBoarding": {
            "title": "Welcome to FunFigz Designer",
            "title2": "Help Topics",
            "content": "Welcome to FunFigz Designer, a 3D design and prototyping tool for creating and sharing 3D models.This guided tour will introduce you to the essential features of the Designer Module.",
            "content2": "Select a topic below to learn more about a specific feature or step. You can revisit any part of the guide at any time."
        },
        "coupon": {
            "heading": "Copy your code from here:",
            "code": "Code",
            "couponNotFound": "COUPONS NOT FOUND",
            "noCouponAvaialble": "No coupons available at this moment."
        },
        "payment": {
            "heading": "Select the mode of payment",
            "option": {
                "cod": "Cash On Delivery",
                "online": "Online Payment"
            },
            "reward": "Use my reward {{coins}} coins.",
            "codLoginRequiredMessage": "Note: Cash on Delivery is accessible only after logging in"
        },
        "login": {
            "button": {
                "continueAsGuest": "Continue as a Guest",
                "continue": "Continue"
            },
            "placeholder": {
                "mobile": "Mobile Number *"
            },
            "or": "OR",
            "signInRegister": "Sign in or Register",
            "mobileReq": "Mobile number is required",
            "validMobile": "Please enter the valid mobile number",
            "trouble": "Having trouble logging in?",
            "getHelp": "Get Help",
            "verifyMobile": "Verify your Phone number",
            "enterOtp": "Enter the OTP code here",
            "otpReq": "OTP is required",
            "validOtp": "Enter a valid 6-digit OTP",
            "success": "Successfully Logged In",
            "continue": "Continue",
            "unsuccesss": "Log In Failed"
        },
        "duplicatestructure": {
            "title": "Overlapping Shapes Detected",
            "content": "Your structure contains overlapping shapes. Please delete  the overlapping shapes to continue"
        }
    },
    "login": {
        "heading": {
            "login": "Login"
        },
        "label": {
            "phoneNo": "Mobile number",
            "otp": "Otp"
        },
        "invalidMessage": {
            "mobileNoInvalid": "Please enter a valid 10-digit phone number.",
            "mandatory": "field is mandatory.",
            "otpInvalid": "OTP should contain only 6 digits."
        },
        "button": {
            "submitOtp": "Submit OTP",
            "sendOtp": "Send OTP"
        },
        "resendOTP": "Resend OTP"
    },
    "productDetails": {
        "actualPrice": "Actual Price",
        "discountedPrice": "Discounted Price",
        "taxesMessage": "Price inclusive all the taxes",
        "offer": "OFFER",
        "rating": "Rating",
        "reviews": "Reviews",
        "structureDetails": "Structure Details",
        "viewIn3DDesigner": "View in 3D Designer",
        "couponMessage": "Copy this promo code and paste when you checkout at",
        "freeDelivery": "Free Delivery",
        "Returnable": "Returnable",
        "funfigzDelivery": "Funfigz Delivery",
        "secureTransaction": "Secure Transaction",
        "shapeDetail": "View Count",
        "quantity": "Net Quantity",
        "specifications": "SPECIFICATION",
        "description": "DESCRIPTION:",
        "shape": "Blocks",
        "selectColor": "Select Colour",
        "deliveryOptions": "Delivery Options",
        "getIt": "Get it by",
        "payOn": "Pay on delivery available.",
        "easy&Days": "Easy 7 days return & exchange available.",
        "clickOnLink": "Click on this link to get the structure's link",
        "productDetails": "Product Details",
        "viewMore": "View More",
        "button": {
            "productDetailAddBtn": "Add To Cart",
            "productDetailGoToBtn": "Go To Cart",
            "buyProductBtn": "Buy It Now",
            "copyBtn": "Copy",
            "addBtn": "Add",
            "viewMoreBtn": "View More",
            "goToHomeBtn": "Go to Home",
            "wishlist": "Add to Wishlist",
            "removeWishlist": "Remove from Wishlist"
        },
        "heading": {
            "similarProduct": "You may be interested in"
        },
        "placeholder": {
            "enterPin": "Enter your Pin Code"
        },
        "invalidMessage": {
            "productNotFound": "Product Not Found",
            "productNotFoundMessage": "We couldn't find the product you're looking for.",
            "noIntersectionFound": "No intersection found",
            "invalidFace": "Invalid face",
            "selectChoice": "Please select your choice",
            "faceIndexNotFound": "Face index not found",
            "invalidIntersection": "Invalid intersection data",
            "objectNotBuffegeometry": "The selected object is not a BufferGeometry",
            "selectYourChoice": "Please Select Your Choice",
            "clickOnFaceToChangeSelection": "Click on the face to change the selection.",
            "outOfStock": "Currently out of stock",
            "outOfStockMessage": "We’re restocking this item soon. You can notified or explore similar products in the meantime"
        }
    },
    "checkout": {
        "notLoginMessage": "Already have an account?",
        "login": "Login",
        "deliverTo": "Deliver To",
        "shippingAddress": "Shipping Address",
        "productName": "Product Name",
        "quantity": "Quantity",
        "price": "Price",
        "orderSummary": "Order Summary",
        "totalMrps": "Total MRPs",
        "subTotal": "Sub Total",
        "total": "Total Amount",
        "discount": "Discount",
        "shipping": "Shipping",
        "coinsUsed": "Coins Used",
        "couponDiscount": "Coupon Discount",
        "amountToBePaid": "Amount to be paid",
        "savingsMessage": "You will save {{currency}} {{amount}} on this order",
        "agreementMessage": "By placing an order, you agree to the funfigz's",
        "privacyPolicy": "Privacy Policy",
        "termsConditions": "Terms & Conditions",
        "useRewardMessage": "Use my reward {{ totalCoinBalance }} coins.",
        "applyCoupon": "Apply Coupon",
        "viewAllCoupons": "View All Coupons",
        "amountSaved": "Saved",
        "couponMessage": "Copy this promo code and paste when you checkout at",
        "availableCoupons": "Available Coupons",
        "unavailableCoupons": "No Coupons Available",
        "couponNotFound": "COUPONS NOT FOUND",
        "couponNotFoundMessage": "No coupons available at this moment.",
        "minOrderAmount": "Note: You must have a minimum order amount of Rs.200 to place your order.",
        "minPurchase": "Min.purchase:",
        "validTill": "Valid till:",
        "couponInvalid": "This coupon is invalid or does not exist.",
        "addMoreItem": "Please add more items to avail this offer.",
        "applied": "applied",
        "firstUserCoupon": "New User Discount",
        "firstUserCouponSideBarMsg": "🎉 Welcome! Your first order just got sweeter — you’ve received Discount",
        "button": {
            "changeBtn": "Change",
            "addBtn": "Add",
            "placeOrderBtn": "Place Order",
            "proceedBtn": "Proceed",
            "payNowBtn": "Pay Now",
            "applyBtn": "Apply"
        },
        "shapeFacetype": {
            "node": "Node",
            "hole": "Hole",
            "plane": "Plane"
        },
        "paymentMethod": {
            "onlinePayment": "Online Payment",
            "cashOnDelivery": "Cash On Delivery"
        }
    },
    "orderSuccess": {
        "orderId": "Order ID",
        "orderConfirmed": "Order Confirmed !",
        "orderSuccessMessage": "Your order has been placed successfully.",
        "orderDeliveryMessage": "Get delivery by Mon, 06 Feb - Thu, 09 Feb",
        "button": {
            "trackMyOrder": "Track My Order",
            "continueShopping": "Continue Shopping"
        }
    },
    "Product3DviewinDesigner": {
        "name": "Name",
        "face-Pattern": "Face-Pattern",
        "count": "Count",
        "shape": "Shape",
        "countInformation": "Count Information"
    },
    "designer": {
        "getCountDetails": {
            "heading": {
                "countInformation": "Count Information"
            },
            "tableHeading": {
                "shapes": "Shapes",
                "facePattern": "Face-Pattern",
                "color": "Colour",
                "count": "Count",
                "connectionData": "Connection Data"
            }
        },
        "tooltip": {
            "copy": "Copy (Cmd/Ctrl + C)",
            "paste": "Paste (Cmd/Ctrl + V)",
            "undo": "Undo (Cmd/Ctrl + Z)",
            "redo": "Redo (Shift + Cmd/Ctrl + Z)",
            "delete": "Delete (delete)",
            "zoomIn": "Zoom In",
            "zoomOut": "Zoom Out",
            "duplicate": "Duplicate (Cmd/Ctrl + D)"
        },
        "actionBtnCont": {
            "button": {
                "guidebtn": "Guide",
                "actionBtn": "Actions"
            },
            "details": {
                "selectcolor": "Select Colour",
                "getCount": "View Count",
                "totalBlock": "Total Blocks"
            }
        },
        "mobileWarningMessage": {
            "message": " The designer is not available on small screens.Please use a <strong>tablet</strong> or <strong>desktop device</strong> (with a screen size larger than 9 inches) to access this feature."
        },
        "invalidMessage": {
            "gridUnavailable": "Sorry, the selected grid is currently unavailable",
            "invalidPointGeneration": "Invalid Point Of Generation Shape Outside Canvas",
            "invalidJoin": "Invalid join",
            "selectShape": "Select a shape to Add",
            "invalidPointJoin": "Invalid point of join",
            "cannotPlace": "Cannot place on Curved Surface",
            "cannotPublishCurrentStatus": "Publishing is currently unavailable for this structure.",
            "shapeIsNotValid": "One or more shapes are not valid and cannot be saved",
            "collisionDetected": "Cannot paste or duplicate here due to collision. Try another grid or make sure there's enough space.",
            "cannotPlaceDisconnectedStructure": "Disconnected structures can only be pasted on the plane. To paste on other surfaces, please paste one structure first and then the next.",
            "disableRotationAction": "You cannot perform rotation while a copy/paste action is active.",
            "disableColorChangeAction": "You cannot perform colour change while a copy/paste action is active.",
            "disableUndoRedoAction": "You cannot perform undo/redo/ action while a copy/paste action is active.",
            "disableDragAction": "You cannot perform drag object(s) while a copy/paste action is active.",
            "disableDuplicate": "You cannot perform duplicate action while a copy/paste action is active."
        }
    },
    "orderInfo": {
        "formLabel": {
            "filterStatus": "Filter Status"
        },
        "option": {
            "all": "All"
        },
        "orderDetails": {
            "orderDetails": "Order Details",
            "orderId": "Order ID",
            "awbNumber": "AWB Number",
            "courierName": "Courier Name",
            "utrNumber": "UTR Number",
            "pickupDate": "Pickup Date",
            "pickupTime": "Pickup Time",
            "accountHolderName": "Account Holder Name",
            "accountNo": "Account Number",
            "ifscCode": "IFSC Code",
            "upiId": "UPI Id",
            "refundAmount": "Refund Amount",
            "payment": "Payment",
            "orderStatus": "Order Status",
            "paymentStatus": "Payment Status",
            "refundStatus": "Refund Status",
            "productName": "Product Name",
            "quantity": "Quantity",
            "price": "Price",
            "subTotal": "Sub Total",
            "couponDiscount": "Coupon Discount",
            "shipping": "Shipping",
            "total": "Total Amount",
            "coinsUsed": "Coins Used",
            "payableAmount": "Payable Amount",
            "amountCharged": "Amount Charged",
            "name": "Name",
            "phoneNo": "Mobile number",
            "email": "Email",
            "address": "Address",
            "status": "Status",
            "customerInfor": "Customer Information",
            "bankDetails": "Bank Details"
        },
        "statusHeading": {
            "exchangeOrderStatus": "Exchange Order Status",
            "returnOrderStatus": "Return Order Status"
        },
        "currency": {
            "rs": "Rs."
        }
    },
    "header": {
        "label": {
            "home": "Home",
            "design": "Design",
            "cart": "Cart",
            "cancel": "Cancel",
            "welcome": "Welcome"
        }
    },
    "addressList": {
        "label": {
            "address": "Address",
            "default": "Default",
            "deliveryEstimates": "Delivery Estimates",
            "deliveryBtw": "Estimated Delivery between 7 to 8 days",
            "totalMrp": "Total MRP",
            "discount": "Discount",
            "subTotal": "Sub Total"
        },
        "button": {
            "addAddress": "Add Address",
            "changeAddress": "Change Address",
            "SetAsDefault": "Set as Default",
            "delete": "Delete",
            "edit": "Edit"
        }
    },
    "profileDetail": {
        "heading": "Profile Details",
        "fullName": "Full Name",
        "mobile": "Mobile Number",
        "email": "Email Id",
        "age": "Age"
    },
    "returnReplaceCancel": {
        "heading": {
            "return": "Tell us why you're returning and choose your refund method.",
            "exchange": "Tell us why you want to exchange this item.",
            "cancel": "Cancel your Poduct(s)"
        },
        "questioning": {
            "return": "Why are you returning this product?",
            "exchange": "Why are you exchanging this product?",
            "cancel": "Why are you Cancelling this product?"
        },
        "selectOtion": "Select how you'd like to receive your refund",
        "button": {
            "continue": "Continue"
        }
    },
    "orderItemList": {
        "button": {
            "return": "Return Item(s)",
            "exchange": "Exchange Item(s)",
            "cancel": "Cancel Item(s)",
            "selectAll": "Select All",
            "unselectAll": "Unselect All",
            "back": "Back to Orders"
        },
        "heading": {
            "return": "Select the item(s) that you want to return",
            "exchange": "Select the item(s) that you want to exchange",
            "cancel": "Select the item(s) that you want to cancel"
        },
        "moItem": "No items in this order are eligible to",
        "exchange": "exchange",
        "return": "return",
        "cancel": "cancel",
        "noOrder": "Order not found or unauthorized."
    },
    "userReviewPage": {
        "heading": "Review Your Products",
        "button": {
            "review": "Write a review",
            "submit": "Submit",
            "continue": "Continue",
            "viewMore": "View More"
        },
        "questioning": "How was the item?",
        "label": {
            "writeReview": "Write a review",
            "sharePhoto": "Share a photo",
            "reviewSubmitted": "Review Submitted",
            "wish": "Awesome! Thank you for helping other shoppers!",
            "rating": "RATINGS",
            "verified": "100+ VERIFIED BUYERS",
            "customerReviews": "Customer Reviews"
        },
        "placeholder": {
            "review": "What should other customer know?"
        }
    },
    "orderStatus": {
        "packageHanded": "Package was handed to resident",
        "help": "Help",
        "deliveryByFunfigz": "Delivery By Funfigz",
        "viewOrderInfo": "View Order Info",
        "shippingAddress": "Shipping Address",
        "mobile": "Mobile",
        "order": "ORDER",
        "total": "TOTAL",
        "shipTo": "SHIP TO",
        "orderId": "ORDER ID",
        "viewOrder": "View order details",
        "invoice": "Invoice",
        "shipped": "Shipped",
        "facility": "Package has left the facility",
        "requestCancellation": "Request Cancellation"
    },
    "orderDetailInfo": {
        "orderDetails": "Order Details",
        "orderId": "Order ID",
        "order": "Order",
        "orderStatus": "Order Status",
        "refundStatus": "Refund Status",
        "invoice": "Invoice",
        "shipTo": "Ship To",
        "paymentMethods": "Payment Methods",
        "status": "Status",
        "paymentStatus": "Payment Status",
        "priceDetails": "Price Details"
    }
}
